import flatpickr from "flatpickr";
import flatpickerDanish from "flatpickr/dist/l10n/da";

export default class DatePicker {
	private datePicker: any;
	private dateInput: HTMLInputElement;

	constructor(inputDateSelector: string, dateLanguage: string) {
		this.dateInput = document.querySelector(inputDateSelector);

		this.init(inputDateSelector, dateLanguage);
	}

	private init(dateInputSelector: string, language: string) {
		flatpickerDanish.default.firstDayOfWeek = 1;

		this.datePicker = flatpickr(dateInputSelector, {
			allowInput: false,
			enableTime: false,
			disableMobile: true,
			locale: language.includes("da") ? flatpickerDanish.da : flatpickerDanish.default,
			nextArrow: '<img src="/assets/right_arrow.png" style="margin-bottom: 5px;" />',
			prevArrow: '<img src="/assets/left_arrow.png" style="margin-bottom: 5px;" />',
		});
	}

	public setProperty(name: string, value: any) {
		this.datePicker.set(name, value);
	}

	public get isValid(): boolean {
		return !isNaN(Date.parse(this.dateInput.value));
	}

	public get DateValue(): Date {
		return new Date(this.dateInput.value);
	}

	public destroy() {
		this.datePicker.destroy();
	}
}
